import React, { useState } from 'react';
import { Button, Checkbox, Stack, Cluster, Text, Icon } from '@iqueue/iq-ui';
import Modal from '../ui/Modal';
import Field from '../ui/Field';
import Select from '../ui/Select';
import { agentIcon } from '../../lib/agentRegistry';

const NO_CONTEXT = '__none__';

export default function CreateRoomDialog({ open, onClose, agents, contexts, onCreate, me }) {
  const [id, setId] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [selectedAgents, setSelectedAgents] = useState([]);
  const [contextId, setContextId] = useState(NO_CONTEXT);
  const [error, setError] = useState('');

  const toggleAgent = (agentId) => {
    setSelectedAgents(prev =>
      prev.includes(agentId) ? prev.filter(a => a !== agentId) : [...prev, agentId]
    );
  };

  const handleSubmit = async () => {
    if (!id.trim() || !name.trim()) return;
    setError('');
    try {
      await onCreate({
        id: id.trim(),
        name: name.trim(),
        description: description.trim(),
        members: [me, ...selectedAgents].filter(Boolean),
        // Контекст комнаты сервер принимал с самого начала — не хватало только
        // места, где его выбрать.
        defaultContextId: contextId === NO_CONTEXT ? null : contextId,
      });
      setId(''); setName(''); setDescription(''); setSelectedAgents([]); setContextId(NO_CONTEXT);
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Новая комната"
      actions={(
        <>
          <Button variant="text" onClick={onClose}>Отмена</Button>
          <Button onClick={handleSubmit} disabled={!id.trim() || !name.trim()}>Создать</Button>
        </>
      )}
    >
      {/* gap — токен библиотеки (число), а не CSS-строка: `gap="var(--md-sys-spacing-200)"`
          не совпадал ни с одним правилом, и весь диалог шёл вообще без отступов. */}
      <Stack gap={200}>
        <Field label="ID комнаты" value={id} onChange={setId} required autoFocus />
        <Field label="Название" value={name} onChange={setName} required />
        <Field label="Описание" value={description} onChange={setDescription} multiline rows={2} />
        <Select
          label="Контекст по умолчанию"
          value={contextId}
          onChange={setContextId}
          options={[
            { value: NO_CONTEXT, label: 'без контекста' },
            ...(contexts || []).map(c => ({ value: c.id, label: c.name })),
          ]}
        />
        <Stack gap={100}>
          <Text variant="label-large" render={<span />}>Агенты</Text>
          <Stack gap={50}>
            {agents.map(agent => (
              <Checkbox
                key={agent.id}
                checked={selectedAgents.includes(agent.id)}
                // Был `onChange` — у headless-чекбокса такого пропа нет, и агента
                // в новую комнату нельзя было выбрать вообще.
                onCheckedChange={() => toggleAgent(agent.id)}
              >
                <Cluster gap={50} align="center" wrap={false}>
                  <Icon name={agentIcon(agent.avatar)} size="s" />
                  {agent.name}
                </Cluster>
              </Checkbox>
            ))}
          </Stack>
        </Stack>
        {error && <Text variant="body-small">{error}</Text>}
      </Stack>
    </Modal>
  );
}
